var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientLicenseWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 185,
    height: 185,
    viewBox: "0 0 185 185",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8646_3119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.5 15.4167C135.073 15.4167 169.583 49.927 169.583 92.5001C169.583 135.073 135.073 169.583 92.5 169.583C49.9269 169.583 15.4167 135.073 15.4167 92.5001C15.4167 49.927 49.9269 15.4167 92.5 15.4167ZM92.5 115.625C90.4556 115.625 88.495 116.437 87.0494 117.883C85.6038 119.328 84.7917 121.289 84.7917 123.333C84.7917 125.378 85.6038 127.338 87.0494 128.784C88.495 130.23 90.4556 131.042 92.5 131.042C94.5444 131.042 96.505 130.23 97.9506 128.784C99.3962 127.338 100.208 125.378 100.208 123.333C100.208 121.289 99.3962 119.328 97.9506 117.883C96.505 116.437 94.5444 115.625 92.5 115.625ZM92.5 46.2501C90.612 46.2503 88.7897 46.9435 87.3788 48.1981C85.9679 49.4527 85.0665 51.1815 84.8456 53.0565L84.7917 53.9584V100.208C84.7939 102.173 85.5462 104.063 86.8949 105.491C88.2436 106.92 90.0869 107.78 92.0483 107.895C94.0096 108.01 95.9409 107.372 97.4475 106.111C98.9541 104.85 99.9223 103.061 100.154 101.11L100.208 100.208V53.9584C100.208 51.914 99.3962 49.9534 97.9506 48.5078C96.505 47.0622 94.5444 46.2501 92.5 46.2501Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8646_3119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 185,
    height: 185,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientLicenseWarning);
export default __webpack_public_path__ + "static/media/clientLicenseWarning.367fae0574b71a72ce0bccff8c6675c4.svg";
export { ForwardRef as ReactComponent };